import React from 'react';
import MarketList from './MarketList';

export default function ETHMarket({ intent = 'sell' }) {
  return <MarketList intent={intent} coin="ETH" />;
}
